export const calcChange = (currentValue: number, previousValue: number): number => {
    if (previousValue === 0) {
        return NaN;
    }
    return (currentValue - previousValue) / previousValue;
};
